import { buildUniqueIdName } from '~/helpers/seo-helpers';
var Accordion = () => import('~/components/molecules/Accordion.vue');
var MdmLink = () => import( /* webpackChunkName: "link-desktop" */'~/components/atoms/MdmLink.vue');
export default {
  name: 'NavItemFolders',
  components: {
    Accordion,
    MdmLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buildUniqueIdName
    };
  }
};